import { Pipe, PipeTransform } from '@angular/core';
import { TransportMode } from '../models/shipment';

@Pipe({
  name: 'transportModeIcon',
  standalone: true
})
export class TransportModeIconPipe implements PipeTransform {
  iconMap = new Map<TransportMode, string>([
    ['Air', 'air'],
    ['Courier', 'courier'],
    ['Rail', 'rail'],
    ['Ocean', 'ocean'],
    ['Road', 'road']
  ]);

  transform(value: string): string {
    if (!this.iconMap.has(value as TransportMode)) {
      return '';
    }

    return `/icons/${this.iconMap.get(value as TransportMode)}.png`;
  }
}
